import request from "@/utils/request";

// 请求歌曲
export function updateservicelocation(params) {
  return request({
    url: "/api/update-service-location",
    method: "POST",
    params,
    silentError: true
  });
}

// 请求歌曲
export function requestsong(params) {
  return request({
    url: "/api/request-song",
    method: "POST",
    params
  });
}

// 获取新闻列表
export function news(params) {
  return request({
    url: "/api/news/data",
    method: "get",
    params
  });
}

// 获取新闻详情
export function newsDetail(id) {
  return request({
    url: `/api/news/detail/${id}`,
    method: "get"
  });
}

// 商城相关
// 获取商城左侧图配置
export function shopleftimage(params) {
  return request({
    url: "/api/shop/left-image",
    method: "get",
    params
  });
}

// 获取商城产品列表
export function shopproducts(params) {
  return request({
    url: "/api/shop/products",
    method: "get",
    params
  });
}

// 获取商城产品详情
export function shopproduct(params) {
  return request({
    url: "/api/shop/product",
    method: "get",
    params
  });
}

// 添加商品到购物车
export function shopcaradd(params) {
  return request({
    url: "/api/shop-car/add",
    method: "POST",
    params
  });
}

// 删除购物车商品
export function shopcarremove(params) {
  return request({
    url: "/api/shop-car/remove",
    method: "DELETE",
    params
  });
}

export function shopcarremovebatch(params) {
  return request({
    url: "/api/shop-car/batch-remove",
    method: "DELETE",
    params
  });
}

// 购物车列表&&订单信息展示页
export function shopcar(params) {
  return request({
    url: "/api/shop-car",
    method: "get",
    params
  });
}
export function shopcarguest(params) {
  return request({
    url: "/api/get-cart",
    method: "get",
    params
  });
}

// 获取用户购物车商品数量
export function shopcarcount(params) {
  return request({
    url: "/api/shop-car/count",
    method: "get",
    params
  });
}

// 修改用户收货地址
export function addressupdate(params) {
  return request({
    url: "/api/shop-order/address/update",
    method: "POST",
    params
  });
}
export function addressedit(params) {
  return request({
    url: "/api/shop-order/address/edit",
    method: "POST",
    params
  });
}
export function addressadd(params) {
  return request({
    url: "/api/shop-order/address/add",
    method: "POST",
    params
  });
}
export function addressupdateprimary(params) {
  return request({
    url: "/api/shop-order/address/update-primary",
    method: "POST",
    params
  });
}
// 订阅支付
export function subscriptionpayment(params) {
  return request({
    url: "/api/shop-order/subscriptionpayment",
    method: "POST",
    params
  });
}

export function subscriptionpaymentpublic(params) {
  return request({
    url: "/api/public/subscriptionpayment",
    method: "POST",
    params
  });
}

// 用户支付方式鉴权
export function authorizepayment(params) {
  return request({
    url: "/api/shop-order/authorize/payment",
    method: "get",
    params
  });
}

// 用户支付方式鉴权-新
export function authorizepaymentnew(params) {
  return request({
    url: "/api/shop-order/authorize/paymentnew",
    method: "get",
    params
  });
}

export function authorizepaymentnewPublic(params) {
  return request({
    url: "/api/public/authorize/paymentnew",
    method: "get",
    params
  });
}


// 获取鉴权结果
export function getauthorizeresult(params) {
  return request({
    url: "/api/shop-order/getauthorizeresult",
    method: "get",
    params
  });
}

export function subscriptionhistory(params) {
  return request({
    url: "/api/device/subscription/history",
    method: "get",
    params
  });
}

//检索凭证数据
export function getvoucher(params) {
  return request({
    url: "/api/get-voucher",
    method: "get",
    params
  });
}

// 代金券有效性验证
export function validatevoucher(params, config = {}) {
  return request({
    url: "/api/shop-order/validate-voucher",
    method: "POST",
    params,
    ...config
  });
}

export function validatevoucherguest(params, config = {}) {
  return request({
    url: "/api/validate-voucher-guest",
    method: "POST",
    params,
    ...config
  });
}

// 代金券取消
export function cancelvoucher(params) {
  return request({
    url: "/api/shop-order/cancel-voucher",
    method: "POST",
    params
  });
}

export function cancelvoucherguest(params) {
  return request({
    url: "/api/cancel-voucher-guest",
    method: "POST",
    params
  });
}

// 下单&&支付
export function shopordercheckout(params) {
  return request({
    url: "/api/shop-order/checkout",
    method: "POST",
    params
  });
}

export function shopordercheckoutpublic(params) {
  return request({
    url: "/api/checkout",
    method: "POST",
    params
  });
}

export function shopordercheckoutguest(params) {
  return request({
    url: "/api/checkout-guest",
    method: "POST",
    params,
    silentError: true
  });
}


// 获取支付结果
export function getpaymentresult(params) {
  return request({
    url: "/api/shop-order/getpaymentresult",
    method: "get",
    params
  });
}

// 获取订单列表
export function shoporderlist(params) {
  return request({
    url: "/api/shop-order/list",
    method: "get",
    params
  });
}

// 获取订单详情
export function shoporderdetail(params) {
  return request({
    url: "/api/shop-order/detail",
    method: "get",
    params
  });
}

// 订阅管理列表
export function subscriptionlist(params) {
  return request({
    url: "/api/device/subscription/list",
    method: "get",
    params
  });
}
// 订阅管理详情
export function subscriptiondetail(params) {
  return request({
    url: "/api/device/subscription/detail",
    method: "get",
    params
  });
}
// 支付账单列表
export function paymentbills(params) {
  return request({
    url: "/api/shop-order/payment-bills",
    method: "get",
    params
  });
}
// 修改设备名称
export function updatename(params) {
  return request({
    url: "/api/device/update-name",
    method: "POST",
    params
  });
}
// 绑定mac
export function bindmac(params) {
  return request({
    url: "/api/device/bind-mac",
    method: "POST",
    params
  });
}
// 可绑定mac列表
export function bindable(params) {
  return request({
    url: "/api/device/bindable-devices",
    method: "get",
    params
  });
}
// 获取可切换的订阅计划列表
export function subscribeplans(params) {
  return request({
    url: "/api/device/subscribe-plans",
    method: "get",
    params
  });
}


export function subscribeplanspublic(params) {
  return request({
    url: "/api/public/subscribe-plans",
    method: "get",
    params
  });
}

// 切换订阅计划

export function subscribepurchase(data) {
  return request({
    url: "/api/device/subscribe-plan/purchase",
    method: "POST",
    data
  });
}

// 取消自动计划

export function cancelrenewal(data) {
  return request({
    url: "/api/device/subscribe-plan/cancel-renewal",
    method: "POST",
    data
  });
}


// 支付账单生成发票
export function paymentinvoice(params) {
  return request({
    url: "/api/shop-order/payment-bills/invoice",
    method: "get",
    params
  });
}

// 获取待支付订单支付详情
export function paymentbilldetail(params, config = {}) {
  return request({
    url: "/api/shop-order/payment-bill-detail",
    method: "get",
    params,
    ...config
  });
}

export function paymentbillPublic(id) {
  return request({
    url: `/api/public/payment-link/${id}`,
    method: "get",
  });
}

// 取消账单支付
export function cancelbillpayment(params) {
  return request({
    url: "/api/shop-order/cancel-bill-payment",
    method: "POST",
    params
  });
}


// 获取token是否登录
export function checktokenstatus(params) {
  return request({
    url: "/api/hp-user/check-token-status",
    method: "get",
    params
  });
}



// 获取帮助中心前两级分类
export function catetop(params) {
  return request({
    url: "/api/help/cate-top",
    method: "get",
    params
  });
}
// 根据上级分类获取下级分类

export function cateson(params) {
  return request({
    url: "/api/help/cate-son",
    method: "get",
    params
  });
}


// 获取分类所有问题
export function catefaq(params) {
  return request({
    url: "/api/help/cate-faq",
    method: "get",
    params
  });
}

// 申请注销/取消注销
export function deactivateaccount(data) {
  return request({
    url: "/api/hp-user/deactivate-account",
    method: "POST",
    data
  });
}

// ACTIVATION MAC-------------------------
export function searchmac(params) {
  return request({
    url: "/api/mac/search",
    method: "GET",
    params
  });
}

export function validateVoucherExternal(params) {
  return request({
    url: "/api/validate-voucher-external",
    method: "GET",
    params
  });
}

// HISTORY MAC-------------------------
export function historymac(params) {
  return request({
    url: "/api/mac/history",
    method: "GET",
    params
  });
}

export function searchBill(params) {
  return request({
    url: "/api/public/search/bill",
    method: "GET",
    params
  });
}

// ADDRESS INPUT-------------------------
export function addressCountries() {
  return request({
    url: "/api/address/countries",
    method: "get",
  });
}
 
export function addressProvinces(params) {
  // params: { country_name }
  return request({
    url: "/api/address/provinces",
    method: "get",
    params,
  });
}
 
export function addressCities(params) {
  // params: { country_name, province_name }
  return request({
    url: "/api/address/cities",
    method: "get",
    params,
  });
}
 
export function addressDistricts(params) {
  // params: { country_name, province_name, city_name }
  return request({
    url: "/api/address/districts",
    method: "get",
    params,
  });
}
 
export function addressSubdistricts(params) {
  // params: { country_name, province_name, city_name, district_name }
  return request({
    url: "/api/address/subdistricts",
    method: "get",
    params,
  });
}
 
export function addressZipcode(params) {
  // params: { country_name, province_name, city_name, district_name, subdistrict_name }
  return request({
    url: "/api/address/zipcode",
    method: "get",
    params,
  });
}